// Global API Configuration
// Prefer environment variable for production builds
// Try HTTPS first, fallback to HTTP for local development


const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // In development, use localhost
  if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
    return 'http://localhost:5000';
  }
  
  // In production, prefer HTTPS
  return 'https://api.cyborgsapient.com';
};

const API_BASE_URL = getApiBaseUrl();

// API Endpoints
export const API_ENDPOINTS = {
  // Admin endpoints
  ADMIN_LOGIN: `${API_BASE_URL}/api/admin/login`,
  ADMIN_SUBADMINS: `${API_BASE_URL}/api/admin/subadmins`,
  ADMIN_CREATE_SUBADMIN: `${API_BASE_URL}/api/admin/create`,
  ADMIN_DELETE_SUBADMIN: `${API_BASE_URL}/api/admin/subadmin`,

  // Influencer endpoints
  INFLUENCER: `${API_BASE_URL}/api/influencer`,
  INFLUENCER_PROFILE: `${API_BASE_URL}/api/influencer/profile`,
  INFLUENCER_LOGIN: `${API_BASE_URL}/api/influencer/login`,
  
  // Premium Influencers
  PREMIUM_INFLUENCERS: `${API_BASE_URL}/api/premium-influencers`,
  PREMIUM_INFLUENCERS_ADMIN: `${API_BASE_URL}/api/premium-influencers/admin`,
  
  // Hire requests
  HIRE_REQUESTS: `${API_BASE_URL}/api/hire-requests`,
  
  // Banners
  BANNERS: `${API_BASE_URL}/api/banners`,
  
  // Contact/Inquiry
  CONTACT: `${API_BASE_URL}/api/contact`,
  
  // Blogs
  BLOGS: `${API_BASE_URL}/api/blogs`,
  
  // Courses
  COURSES: `${API_BASE_URL}/api/courses`,
};

// Utility function to get full URL for image paths
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (imagePath.startsWith('http')) return imagePath;
  return `${API_BASE_URL}${imagePath}`;
};

// Utility function to make API calls
export const apiCall = async (endpoint, options = {}) => {
  try {
    const response = await fetch(endpoint, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

// Export the base URL for direct use
export { API_BASE_URL }; 